// extracted by mini-css-extract-plugin
export var active = "_uo-1";
export var circle = "_uo-0";
export var completed = "_uo-2";
export var connector = "_uo-4";
export var connectorCompleted = "_uo-7";
export var connectorSpacer = "_uo-5";
export var iconStrokeOverride = "_uo-8";
export var labelContainer = "_uo-6";
export var pending = "_uo-3";